import { usePrefetchBreadcumbItems } from 'services/v1/Common/NavBarMenuService';
import { usePrefetchSubjectDetails } from 'services/v1/SystemTenant/AROKMS/SubjectService';
import { usePrefetchDisplayEventTable } from 'services/v1/Tenant/AROEvent/EventTableService';
import { usePrefetchDataInputTable } from 'services/v1/Tenant/AROKMS/DisplayTableService';
import { usePrefetchKtreeData } from 'services/v1/Tenant/AROKMS/KTreeDataService';
import { usePrefetchChartViewDetails } from 'services/v1/SystemTenant/AROChart/ChartViewDefinitionService';
import { usePrefetchChartFullData } from 'services/v1/Tenant/AROChart/ChartViewService';
import { usePrefetchInsightViewFullData } from 'services/v1/Tenant/AROCube/CubeInsightViewService';
import { usePrefetchMyViewDetails } from 'services/v1/Tenant/ConfigurationService';
import { QuickAccessItem } from 'types/api/Tenant/ConfigurationTypes';
import { handlePrefetch } from 'utils/MyViewUtils';

export function useDashboardNaviagationPrefetchHandler() {
  const prefetchMyViewDetails = usePrefetchMyViewDetails();
  const prefetchDataInputTable = usePrefetchDataInputTable();
  const prefetchSubjectDetails = usePrefetchSubjectDetails();
  const prefetchEventTableData = usePrefetchDisplayEventTable();
  const prefetchKTreeData = usePrefetchKtreeData();
  const prefetchBreadcumbItems = usePrefetchBreadcumbItems();
  const prefetchChartViewDetails = usePrefetchChartViewDetails();
  const prefetchChartFullData = usePrefetchChartFullData();
  const prefetchInsightViewFullData = usePrefetchInsightViewFullData();

  return (viewItem: QuickAccessItem, nextViewItem?: QuickAccessItem) => {
    handlePrefetch(
      viewItem,
      nextViewItem || null,
      prefetchMyViewDetails,
      prefetchDataInputTable,
      prefetchSubjectDetails,
      prefetchEventTableData,
      prefetchKTreeData,
      prefetchBreadcumbItems,
      prefetchChartViewDetails,
      prefetchChartFullData,
      prefetchInsightViewFullData
    );
  };
}
